





















import Vue from 'vue'

export default Vue.extend({
  name: 'AppBackToListButton',
  props: {
    link: {
      required: true,
      type: Object
    }
  },
  methods: {
    onClickBackBtn () {
      const listParams = sessionStorage.getItem('listParams')
      const paramsObj = listParams ? JSON.parse(listParams) : null
      if (paramsObj && this.link.name === paramsObj.name) {
        const route = Object.assign(paramsObj, this.link)
        this.$router.push(paramsObj)
        sessionStorage.removeItem('listParams')
      } else {
        this.$router.push(this.link)
      }
    }
  }
})
